/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomerDemographicsListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: CustomerDemographicsService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';

import myGlobals = require('../globals');
import { CustomerDemographicsData, CustomerDemographicsService } from './CustomerDemographics.service';
import { CustomerDemographicsSearchComponent }  from './CustomerDemographicsSearch.component';

@Component({
	selector: 'my-CustomerDemographics',
	template: require('./CustomerDemographicsList.component.html'),
	providers: [CustomerDemographicsService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class CustomerDemographicsListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	CustomerDemographicsList: CustomerDemographicsData[];
	newCustomerDemographics: CustomerDemographicsData;
	selectedCustomerDemographics: CustomerDemographicsData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(CustomerDemographicsSearchComponent) filterComponent: CustomerDemographicsSearchComponent;

	sortExpression: string = "CustomerTypeID";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private CustomerDemographicsService: CustomerDemographicsService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newCustomerDemographics = new CustomerDemographicsData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		//this.CustomerDemographicsService.getAll().subscribe(record => this.CustomerDemographicsList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getCustomerDemographicsByPaging();

		/*
		this.CustomerDemographicsList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getCustomerDemographics() {
		this.CustomerDemographicsService.getAll()
			.subscribe(data => this.CustomerDemographicsList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on CustomerDemographicsSearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getCustomerDemographicsByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getCustomerDemographicsByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getCustomerDemographicsByPaging();
	}
	
	// Get records by paging
	getCustomerDemographicsByPaging() {
		this.CustomerDemographicsService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.CustomerDemographicsList=data.CustomerDemographicsList;
				this.rowsCount=data.RowsCount;
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}

	// Adds new record
	addCustomerDemographics() {
		this.CustomerDemographicsService.addCustomerDemographicsData(this.newCustomerDemographics).subscribe(record => console.log(record));
		this.getCustomerDemographics();
	}

	// Updates existing record
	updateCustomerDemographics() {
		this.CustomerDemographicsService.updateCustomerDemographicsData(this.selectedCustomerDemographics).subscribe(record => console.log(record));
		this.getCustomerDemographics();
	}

	// Deletes record with specified id
	deleteCustomerDemographics(id: string) {
		if (window.confirm('Are you sure you want to delete this CustomerDemographics?') == true)
		{
			this.CustomerDemographicsService.deleteCustomerDemographics(id)
			.subscribe(data => this.getCustomerDemographics(),
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { 
					this.toastr.success('CustomerDemographics record deleted successfully...', 'Delete CustomerDemographics');
					console.log('CustomerDemographics record deleted successfully...'); 
				}
			);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getCustomerDemographicsByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getCustomerDemographicsByPaging();
		}
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getCustomerDemographicsByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getCustomerDemographicsByPaging();
	}

	// On Edit - Go to Edit page
	onSelect(item: CustomerDemographicsData) {
		this.router.navigate(['/CustomerDemographics', item.CustomerTypeID]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: CustomerDemographicsData) {
		this.router.navigate(['/CustomerDemographics/Details', item.CustomerTypeID]);
	}

	// Set record as selected
	SelectCustomerDemographics(item: CustomerDemographicsData) {
		this.selectedCustomerDemographics = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CustomerDemographics/CustomerDemographicsList.component.ts